import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';

import { UrlManageService } from '../services/url-manage.service';

@Injectable({
  providedIn: 'root'
})
export class ProteinSearchService {

  constructor(
    private http: HttpClient,
    private urlList: UrlManageService
  ) { }

  private keys = ["dataset", "created_date", "modified_date", "name", "protein_fullName", "gene_name", "proteinExistence", "sequence_length", "sequence_mass", "sequence_checksum", "sequence", "accession", "organism_scientific_name", "organism_common_name", "organism_synonym_name", "organism_dbReference", "organism_lineage", "organismHost", "reference_id", "dbReference", "keywords", "feature"]



  getSearchResultList(property, value, page){
    if(property == "name"){
      return this.http.get(this.urlList.getProteinResultByName + value + "/" + page)
    }
    else if(property == "accession"){
      return this.http.get(this.urlList.getProteinResultByAccession + value + "/" + page)
    }
    else if(property == "sequence"){
      return this.http.get(this.urlList.getProteinResultBySeq + value + "/" + page)
    }
    else if(property == "keyword"){
      return this.http.get(this.urlList.getProteinResultByKeywords + value + "/" + page)
    }
  }
  


}
